if (customElements.get("quick-add-modal") === undefined) {
	class QuickAddModal extends HTMLElement {
		constructor() {
			super();
			this.dialog = null;
			this._boundHandleClick = this._handleClick.bind(this);
			this._boundHandleDialogClick = this._handleDialogClick.bind(this);
		}

		connectedCallback() {
			const productId = this.dataset.productId;
			const dialogId = this.dataset.dialogId || `quick-add-dialog-${productId}`;
			
			if (!productId) {
				console.warn('QuickAddModal: No product ID provided');
				return;
			}

			this.dialog = document.getElementById(dialogId);
			
			if (!this.dialog) {
				console.warn(`QuickAddModal: Dialog not found for target ${dialogId}`);
				return;
			}

			this._setupEventListeners();
		}

		disconnectedCallback() {
			this._removeEventListeners();
		}

		_setupEventListeners() {
			this.addEventListener('click', this._boundHandleClick);
			
			if (this.dialog) {
				const closeButton = this.dialog.querySelector('.pch__dialog-close');
				
				if (closeButton) {
					closeButton.addEventListener('click', () => this._closeDialog());
				}

				this.dialog.addEventListener('click', this._boundHandleDialogClick);
			}
		}

		_removeEventListeners() {
			this.removeEventListener('click', this._boundHandleClick);
			
			if (this.dialog) {
				const closeButton = this.dialog.querySelector('.pch__dialog-close');
				
				if (closeButton) {
					closeButton.removeEventListener('click', () => this._closeDialog());
				}

				this.dialog.removeEventListener('click', this._boundHandleDialogClick);
			}
		}

		_handleClick(event) {
			event.preventDefault();
			event.stopPropagation();
			this._openDialog();
		}

		_handleDialogClick(event) {
			const rect = this.dialog.getBoundingClientRect();
			const isClickOutside = 
				event.clientY < rect.top ||
				event.clientY > rect.bottom ||
				event.clientX < rect.left ||
				event.clientX > rect.right;

			if (isClickOutside) {
				this._closeDialog();
			}
		}

		_openDialog() {
			if (this.dialog) {
				// Lazy-load videos from templates on first open
				if (!this.dialog.dataset.videosInitialized) {
					const videoTemplates = this.dialog.querySelectorAll('[data-video-template]');

					videoTemplates.forEach(template => {
						const placeholder = template.nextElementSibling;
						if (placeholder && placeholder.classList.contains('carousel__video-placeholder')) {
							// Clone template content and replace placeholder
							const videoElement = template.content.cloneNode(true);

							placeholder.replaceWith(videoElement);
							
							// "videoElement" is a DocumentFragment; get the actual video element.
							const video = template.parentElement.querySelector('video');
							
							// The video sometimes doesn't autoplay on mobile devices - try to play it programmatically.
							if (video && video.autoplay) {
								video.play().catch(error => {
									console.warn('Video autoplay failed:', error);
								});
							}
						}
					});

					this.dialog.dataset.videosInitialized = 'true';
				}

				this.dialog.showModal();

				// Recalculate dimensions for any sliders in the modal
				// This fixes the issue where sliders have slideWidth = 0 when modal opens
				setTimeout(() => {
					const sliders = this.dialog.querySelectorAll('single-image-slider');
					sliders.forEach(slider => {
						if (slider.recalculateDimensions) {
							slider.recalculateDimensions();
						}
					});
				}, 100); // Small delay to ensure modal is fully open
			}
		}

		_closeDialog() {
			if (this.dialog) {
				this.dialog.close();
			}
		}
	}

	customElements.define("quick-add-modal", QuickAddModal);
}
